/**
 * @ngdoc directive
 * @name cbl.cartadebitoint.wa.directive:cdintQuestionari
 * @restrict E
 * @description Componente per la visualizzazione di una pratica di credito
 *              assicurativo
 */
(function () {
  'use strict';
  var CdintQuestionariCtrl = function (
    $q,
    $http,
    $scope,
    $state,
    $stateParams,
    $cacheFactory,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    propostaCartaDebitoIntSrvc,
    $uibModal
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$cacheFactory = $cacheFactory;
    this.messaggiFctr = messaggiFctr;
    this.propostaCartaDebitoIntSrvc = propostaCartaDebitoIntSrvc;
    this.CONSTANTS = CONSTANTS;
    this.$uibModal = $uibModal;
    $scope.msg = labelSrvc.getLabel;

    /**
     * Indica se il caricamento delle labels è andato a buon fine
     */
    this.labelsPronte = false;

    /**
     * Riferimento allo spinner globale
     */
    this.spinner = this.propostaCartaDebitoIntSrvc.spinner;

    /**
     * Copia dei dati pratica contenenti i questionari
     */
    this.datiPratica = null;

    /**
     * Impostazioni datepicker
     */
    this.datepicker = {
      isOpen: false,
      dateOptions: {
        formatDay: 'dd',
        formatMonth: 'MM',
        formatYear: 'yyyy',
        startingDay: 1
      }
    };

    /**
     * Configurazione campi widget trasparenza
     */
    this.transparencyFieldsConfig = {};

    /**
     * Configurazione campi widget kyc
     */
    this.kycFieldsConfig = {};

    /**
     * Riferimento interno al controller per recuperare i valori nelle funzioni
     */
    var self = this;

    /**
     * Implementazione nel service della funzione di abilitazione salvataggio stato pratica
     */
    this.propostaCartaDebitoIntSrvc.salvaAbilitato = function () {
      return self.questionariValidi();
    };

    /**
     * Implementazione nel service della funzione di abilitazione proseguimento iter pratica
     */
    this.propostaCartaDebitoIntSrvc.proseguiAbilitato = function () {
      return self.questionariValidi();
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone prosegui
     */
    this.propostaCartaDebitoIntSrvc.proseguiVisibile = function () {
      return true;
    };
    
    /**
     * Implementazione nel service della funzione di visualizzazione bottone prendi in carica
     */
    this.propostaCartaDebitoIntSrvc.prendiInCaricoVisibile = function () {
      return false;
    };

    /**
     * Implementazione nel service della funzione di visualizzazione bottone rilascia pratica
     */
    this.propostaCartaDebitoIntSrvc.rilasciaPraticaVisibile = function () {
      return false;
    };

    this.questionariValidi = function () {
      // if (
      //   self.datiPratica.specializzazione ===
      //     self.CONSTANTS.SPECIALIZZAZIONI.LIGHT &&
      //   !(
      //     self.propostaCartaDebitoIntSrvc.questionari &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .scopoApertura &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .destinazioneInvestimentoProvincia &&
      //     self.propostaCartaDebitoIntSrvc.questionari.kycRapporto
      //       .destinazioneInvestimentoNazione
      //   )
      // ) {
      //   return false;
      // }

      // Controllo questionari
      if (
        self.datiPratica.specializzazione !== self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS &&
        !(
          self.propostaCartaDebitoIntSrvc.questionari &&
          self.propostaCartaDebitoIntSrvc.questionari.privacyNexi &&
          self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande
        )
      ) {
        return false;
      }

      var enabled = true;

      for (var i = 0; i < self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande.length; i++) {
        var domanda = self.propostaCartaDebitoIntSrvc.questionari.privacyNexi.domande[i];
        if (domanda.valore === null || domanda.valore === undefined) {
          enabled = false;
        }
      }

      return enabled;
    };

    /**
     * Funzione che avvia il recupero della configurazione campi personalizzata per banca e il questionario privacy nexi
     */
    this.recuperaConfigurazioneCampi = function () {
      self.spinner.showSpinner++;

      var configurazioni = [
        self.propostaCartaDebitoIntSrvc.promiseRecuperaQuestionariNexi(
          self.propostaCartaDebitoIntSrvc.datiPratica.idPratica
        )
      ];

      if (
        self.propostaCartaDebitoIntSrvc.datiPratica &&
        self.propostaCartaDebitoIntSrvc.datiPratica.specializzazione !== self.CONSTANTS.SPECIALIZZAZIONI.SMALLBUSINESS
      ) {
        configurazioni.push(
          self.propostaCartaDebitoIntSrvc.promiseRecuperaConfigurazioneCampi(
            'QUESTIONARIO_KYC_RAPPORTO',
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        );
        configurazioni.push(
          self.propostaCartaDebitoIntSrvc.promiseRecuperaConfigurazioneCampi(
            'QUESTIONARIO_TRASPARENZA',
            self.propostaCartaDebitoIntSrvc.datiPratica.intestatario.ndg
          )
        );
      }

      $q.all(configurazioni)
        .then(function (responses) {
          self.propostaCartaDebitoIntSrvc.questionari = {};

          // PRIVACY NEXI
          if (responses[0] && !self.messaggiFctr.processaResponse(responses[0])) {
            self.propostaCartaDebitoIntSrvc.questionari.privacyNexi = responses[0].data.result;
          }

          // KYC
          if (responses[1] && !self.messaggiFctr.processaResponse(responses[1])) {
            var kycConfig = {};
            for (var prop in responses[1].data.result) {
              if (Object.prototype.hasOwnProperty.call(responses[1].data.result, prop)) {
                kycConfig['questionarioKycRapporto.' + prop] = responses[1].data.result[prop];
              }
            }

            self.kycFieldsConfig = kycConfig;

            const rapportoKyc = !!self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              ? self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              : {};

            self.propostaCartaDebitoIntSrvc.questionari.kycRapporto = rapportoKyc.questionarioKycRapporto;
          }

          // TRASPARENZA
          if (responses[2] && !self.messaggiFctr.processaResponse(responses[2])) {
            self.transparencyFieldsConfig = responses[2].data.result;

            const rapportoTrasparenza = !!self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              ? self.propostaCartaDebitoIntSrvc.datiPratica.rapporto
              : {};

            self.propostaCartaDebitoIntSrvc.questionari.trasparenza = {
              codiceClassificazione: rapportoTrasparenza.codiceClassificazione
            };
          }
        })
        .finally(function () {
          if (self.spinner.showSpinner > 0) {
            self.spinner.showSpinner--;
          }
        });
    };

    /**
     *  Funzione richiamata all'avvio del controller
     */
    this.init = function () {
      labelSrvc.labelsPronte.then(function () {
        self.labelsPronte = true;

        // Copio i dati pratica e forzo la creazione del campo naturaGiuridica sull'intestatario
        // per compatibilità con gli widget
        self.datiPratica = JSON.parse(JSON.stringify(self.propostaCartaDebitoIntSrvc.datiPratica));
        self.datiPratica.intestatario.naturaGiuridica = self.datiPratica.intestatario.formaCostitutiva;

        self.recuperaConfigurazioneCampi();
      });
    };

    self.init();
  };

  CdintQuestionariCtrl.$inject = [
    '$q',
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$cacheFactory',
    'CDINT_CONSTANTS',
    'CdintLabelSrvc',
    'CdintMessaggiFctr',
    'CdintPropostaCartaDebitoIntSrvc',
    '$uibModal'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'cdintPropostaCartaDebitoInt/cdintQuestionari/cdintQuestionari.html'
    );
  };

  TemplateUrl.$inject = ['CDINT_CONSTANTS'];

  var CdintQuestionariComponent = {
    controller: CdintQuestionariCtrl,
    controllerAs: 'cdintQuestionariCtrl',
    templateUrl: TemplateUrl
  };

  angular.module('cbl.cartadebitoint.wa').component('cdintQuestionari', CdintQuestionariComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/cdintPropostaCartaDebitoInt/cdintQuestionari/cdintQuestionari.cmpt.js
// module id = 14
// module chunks = 0